var map = {
	"./far1_active.png": "f356",
	"./far2_active.png": "efc0",
	"./far3_active.png": "fecf",
	"./son1_active.png": "c76b",
	"./son2_active.png": "5485",
	"./third1_1_active.png": "a928",
	"./third1_2_active.png": "16e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ab9a";